module.exports = __webpack_public_path__ + "media/male_resultE.282d532a.mp3";